/**
 * The toast sentence for documents that got an extra tag group because they
 * were linked to a question whose tags none of their groups covered.
 *
 * One document: names the added tags. Several (a batch): counts them, since
 * naming every set would not fit a toast.
 *
 * @param addedTagSets The `addedTagSet` of each link response that carried one.
 * @param label Resolves a set's slugs to display names, e.g. `useTagLookup().label`.
 * @returns The sentence, or null when no group was added.
 */
export function addedTagSetMessage(
  addedTagSets: readonly (readonly string[])[],
  label: (tags: readonly string[]) => string,
): string | null {
  const [only, ...rest] = addedTagSets;
  if (only === undefined) return null;
  return rest.length === 0
    ? `Dokumentet fick även taggarna ${label(only)}`
    : `${addedTagSets.length} dokument fick även frågans taggar`;
}
